import * as actions from "./Type";
import Instance from "../util/Instance";
import setToken from "../util/SetToken";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const Add_Todo = (bid, data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newTodo/${bid}`,
        { ...data },
        config
      );
      dispatch(Get_List_Todo());
      dispatch({
        type: actions.ADD_TODO_APP,
        payload: res.data.data,
      });
    } catch (error) {
      toast.error("Todo Created Error");
    }
  };
};

export const Get_List_Todo = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getAgentTodos`, config);
      dispatch({
        type: actions.GET_LIST_TODO_APP,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Update_Checkbox = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      dispatch({
        type: actions.UPDATEING_TODO_APP_CHECKBOX,
      });
    } catch (error) {}
  };
};

export const Delete_Checkbox = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(`/api/v1/deleteAgentTodo/${id}`, config);
      dispatch({
        type: actions.DELETE_TODO_APP_CHECKBOX,
      });
      toast.warn("todo remove from Todo List");
    } catch (error) {}
  };
};

export const Add_Task_Calendar = (data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/TaskCalender`,
        { ...data },
        config
      );
      dispatch({
        type: actions.CREATE_TASK_CALENDAR,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Get_List_Calendar = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/TaskCalenderAgent`, config);
      dispatch({
        type: actions.GET_LIST_CALENDAR_APP,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const View_Each_Task = (taskId) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/TaskCalender/${taskId}`, config);
      dispatch({
        type: actions.VIEW_TASK_CALENDAR,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

// HR request For Transfer Branch
export const Create_Request_Transfer = (data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/RequireForm?type=branch`,
        { ...data },
        config
      );
      dispatch({
        type: actions.REQUEST_TRANSFER,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
// HR request leave
export const Create_Request_Permission = (data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/RequireForm?type=leef`,
        { ...data },
        config
      );
      dispatch({
        type: actions.REQUEST_LEAVE,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

// HR request Salary
export const Create_Request_Salary = (data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/RequireForm?type=salary`,
        { ...data },
        config
      );
      dispatch({
        type: actions.REQUEST_SALARY,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

// HR request Pospon
export const Create_Request_PostPon = (data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/RequireForm?type=postpon`,
        { ...data },
        config
      );
      dispatch({
        type: actions.REQUEST_POSTPON,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

// get list agent requets
export const Get_List_requests = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getRequireAgentForms`, config);
      dispatch({
        type: actions.GET_REQUEST_LISTS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

/// update status
export const Active_Status_Request = (id, status) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/ChangeRequireFormStatus/${id}?status=${status}`,
        config
      );
      dispatch({ type: actions.ACTIVE_REQUESTS });
    } catch (error) {}
  };
};

// view request
export const View_Agent_Request = (id) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getRequireForm/${id}`, config);
      dispatch({
        type: actions.VIEW_REQUESTS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

// HR request For Transfer Branch
export const Create_Send_HRform = (data) => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(`/api/v1/HRForm`, { ...data }, config);
      dispatch({
        type: actions.SEND_HR_FORM,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
